/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Tip_ServiceInputs */



/**
* | output |
* | --- |
* | "The inspection or service you need" |
*
* @param {Contact_Tip_ServiceInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const contact_tip_service = /** @type {((inputs?: Contact_Tip_ServiceInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Tip_ServiceInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("您需要的检查或服务")
	return /** @type {LocalizedString} */ ("The inspection or service you need")
});